import styled from "styled-components";

export const FieldsNote = styled.p`
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
  margin: 4px 0 16px;
  line-height: 1.4;
`;

export const CredentialLabel = styled.div`
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
  margin-bottom: 16px;

  strong {
    font-weight: 600;
  }
`;

export const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 120px;
`;
